import type { DealCard } from '@/app/components/search/utils/buildDealCards/dealCardTypes.ts';
import type { Localization } from '@/app/components/search/common/Localization.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';
import { getDistanceFromKm, getDistanceFromM } from '@/app/common/measures/getters.ts';

export const getLocationLabel = (dealCard: DealCard, localization: Localization, t: TranslationFunction) => {
  const geo = dealCard?.product?.geo;
  const cityDisplayName = geo?.cityDisplayName;
  const cityName = geo?.cityName;
  const isCity = cityDisplayName === cityName;
  const distance = geo?.distanceKm ? `${getDistanceFromKm(geo.distanceKm, localization).formatted}` : '';

  if (geo?.distanceUsp?.nearestBeach?.distanceM) {
    const beachDistance = `${getDistanceFromM(geo.distanceUsp.nearestBeach.distanceM, localization).formatted}`;
    return t('vacation.oss.cards.location_from_beach', { city: cityDisplayName, amount: beachDistance });
  }

  if (geo?.distanceUsp?.nearestSkiLift?.distanceM) {
    const skiDistance = `${getDistanceFromM(geo.distanceUsp.nearestSkiLift.distanceM, localization).formatted}`;
    return t('vacation.oss.cards.location_from_ski', { city: cityDisplayName, amount: skiDistance });
  }

  if (isCity) {
    return t('vacation.oss.cards.location_from_centre', { city: cityDisplayName, amount: distance });
  }

  return t('vacation.oss.cards.location_from_city', {
    region: cityDisplayName,
    amount: distance,
    city: cityName,
  });
};
